import ItemCard from "@/components/ItemCard";
import { ResultItem } from "@/types";
import SearchBar from "./SearchBar";
import { useTranslation } from "react-i18next";

const ItemsGrid = ({ items }: { items: ResultItem[] }) => {
    const { t } = useTranslation(["common", "validation", "glossary"]);

    return (

        <div className="container lg:mx-auto p-4 py-10 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {items.length === 0 ? (
                <div className="text-center text-gray-500 mt-10">
                    {t("no_results", { ns: "glossary" })}
                </div>
            ) : (
                items.map((item) => {
                    return <ItemCard key={item.model + item.name} item={item} />;
                })
            )}
        </div>

    );
};

export default ItemsGrid;
